import React, { ReactNode, LabelHTMLAttributes, useMemo } from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { label_base_css } from './styles';
import { semantic_colors } from '../../foundation';
import { HelpText, HelpTextProps } from '../text';
import { Popover } from '../popover';
import { IconCircleQuestion } from '../icons/generated';
import { CSSValueWithLength, buildCSSWithLength } from '../../styles';
import { css } from '@emotion/react';

export interface FormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** @default false */
  required?: boolean;
  /** 라벨 help 팝오버 콘텐츠 */
  helper?: HelpTextProps;
  /** 라벨 우측 렌더링될 Addon 요소 */
  rightAddon?: ReactNode;
  width?: CSSValueWithLength;
}

export const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>(
  ({ children, required = false, helper, rightAddon, className, width, ...props }, ref) => {
    const helperContent = useMemo(() => {
      if (!helper?.contents) {
        return null;
      }
      return (
        <Popover content={<HelpText title={helper?.title} contents={helper.contents} />}>
          <HelperWrapper>
            <IconCircleQuestion color={semantic_colors.content.tertiary} size={14} />
          </HelperWrapper>
        </Popover>
      );
    }, [helper]);

    return (
      <label
        className={classNames('pds-form-label', className)}
        css={[
          label_base_css,
          css`
            ${width && `${buildCSSWithLength('width', width)}`}
          `,
        ]}
        {...props}
        ref={ref}
      >
        <span>
          {children}
          {required && <RequiredMark>*</RequiredMark>}
        </span>
        {helperContent}
        {rightAddon}
      </label>
    );
  },
);

const RequiredMark = styled.span`
  margin-left: 2px;
  color: ${semantic_colors.state.negative};
`;

const HelperWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2px;
`;
